var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPractice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 153,
    viewBox: "0 0 217 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1714_168961",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 97,
    height: 140
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33984 0H103.151V139.215H7.33984V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1714_168961)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9011 38.2367C41.7625 38.0939 40.1647 35.9374 40.3324 33.4221L41.5758 14.7484C42.0148 14.1761 42.4977 13.7093 43.0223 13.3996C45.5999 11.9212 48.4315 12.1097 50.7945 13.9169C53.3695 15.9478 54.1754 22.2899 53.6881 25.3936C53.0331 29.845 52.3762 34.3008 51.7198 38.7566L43.9011 38.2367Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2993 42.5388C70.2993 42.5388 75.5584 46.244 79.3969 68.5889C83.2354 90.9301 80.7926 90.0807 80.7926 90.0807L80.0973 95.1699L70.3238 96.0193L64.7422 76.7865L70.2993 42.5388Z",
    fill: "#B0BFDE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4554 111.858C50.4554 111.858 58.0471 155.292 65.9566 174.356C72.9683 191.246 81.1451 169.274 81.1451 169.274L68.3485 96.3964L47.2576 94.7964C47.2576 94.7964 45.8055 95.3309 50.4554 111.858Z",
    fill: "#212957"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2148 94.9721L54.8067 122.977L51.1516 125.127C51.1516 125.127 49.0339 166.726 48.3441 168.831C44.3885 180.873 34.157 173.65 32.7613 169.633C31.3656 165.62 29.0374 135.913 29.5016 114.238C29.9677 92.563 29.9677 92.563 29.9677 92.563L52.2148 94.9721Z",
    fill: "#212957"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5904 42.5168L55.1994 35.5677L47.2606 37.9439L37.4447 36.8235L26.6237 41.51C26.6237 41.51 21.7425 46.2038 26.2766 61.2846C30.8144 76.3655 30.1367 101.266 30.1367 101.266L69.4162 103.756C69.4162 103.756 66.7511 50.8939 70.5904 42.5168Z",
    fill: "#D1DBEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.731 41.7991C29.731 41.7991 23.1209 39.4669 18.3919 47.9428C10.3283 62.3866 8.08611 78.9576 7.54973 82.1796C7.01628 85.4052 7.18507 94.7707 11.9001 96.7332C16.6206 98.6993 21.7581 97.3373 21.7581 97.3373L26.4508 83.699L23.078 82.6738L22.8305 82.6116C22.8305 82.6116 24.7333 76.0688 28.3455 65.3486C31.9589 54.632 29.731 41.7991 29.731 41.7991Z",
    fill: "#D1DBEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3216 37.6033L41.4407 41.8431L37.5586 36.2486L39.8875 32.7997L45.3216 37.6033Z",
    fill: "#B0BFDE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.8436 33.1329L46.3789 37.9438L49.9062 42.1799L55.7328 35.5676L53.8436 33.1329Z",
    fill: "#B0BFDE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6745 31.8478C42.5359 31.705 40.9381 29.5485 41.1058 27.0299L42.3488 8.35762C42.7882 7.78536 43.2711 7.31855 43.7958 7.00844C46.3733 5.53001 49.205 5.71856 51.568 7.52614C54.1426 9.5567 54.9488 15.8992 54.4615 19.0025C53.8065 23.4542 53.1497 27.9111 52.4932 32.3677L44.6745 31.8478Z",
    fill: "#EC9568"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6709 3.64007L48.9114 0.0307617L50.4019 0.129983L54.3327 0.391765L56.7063 0.549567C59.3256 0.723845 61.31 2.99312 61.1354 5.61533L60.8952 9.22281L59.4036 9.12359L55.4746 8.86217L53.1014 8.704C50.4795 8.52973 48.4962 6.26265 48.6709 3.64007Z",
    fill: "#163F59"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7439 25.0503C39.5883 27.3807 41.3523 29.3948 43.6831 29.5522L53.264 30.1893C55.5948 30.343 57.6096 28.5805 57.7645 26.2504L59.04 7.09417C59.1953 4.76156 57.4324 2.74382 55.1016 2.58858L45.5207 1.95078C43.1899 1.79554 41.1744 3.56139 41.0192 5.89473L39.7439 25.0503Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6065 0.0106353C46.9461 -0.0999358 45.4281 0.660149 44.4945 1.8951L42.8659 1.78673C40.8347 1.65163 39.0802 3.18937 38.9447 5.22029L38.3398 14.3076L40.9255 14.4801L41.1715 10.7844C41.2667 9.35756 42.5064 8.27381 43.9321 8.36864L45.4424 8.46896L49.3728 8.73074L51.7442 8.88854C54.3708 9.06355 56.6328 7.0806 56.8074 4.45838L57.0663 0.573742L48.6065 0.0106353Z",
    fill: "#163F59"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5864 16.8936C41.6691 15.6502 40.7285 14.5789 39.4815 14.4958L39.2973 14.4837C38.0532 14.401 36.9772 15.3375 36.8944 16.5813L36.7121 19.3185C36.6293 20.5607 37.5714 21.6372 38.8155 21.7199L38.9997 21.732C39.9212 21.7935 40.7487 21.293 41.1525 20.526",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.7659 69.7092L80.3828 79.7888L88.2989 92.0688L89.3599 92.5996L98.8676 71.0126L97.7659 69.7092Z",
    fill: "#C5E1F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.702 69.9948L100.009 70.932L91.6848 89.2129L91.1953 93.0902C91.1953 93.0902 92.3786 93.0097 92.5416 92.8046C92.7049 92.5996 102.702 69.9948 102.702 69.9948Z",
    fill: "#003E99"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.3867 66.524L67.1206 66.6082C67.1206 66.6082 77.0768 74.3994 79.9333 78.317C82.7899 82.2346 88.4414 89.0922 88.8698 91.6222C88.9763 92.2482 89.0499 92.4533 89.0737 92.6217C89.1147 92.9073 89.0737 91.4977 89.0737 91.4977C89.0737 91.4977 89.0331 87.214 90.0125 84.7646C90.9915 82.3188 97.7653 69.7093 97.7653 69.7093C97.7653 69.7093 100.54 70.7711 101.071 70.8516C101.601 70.9322 91.767 92.5595 91.767 92.5595C91.767 92.5595 90.9102 93.6395 89.6043 93.3137C88.2983 92.9878 87.6253 93.3137 86.6664 92.0286C86.397 91.6661 85.6464 89.949 85.6464 89.949L64.3867 66.524Z",
    fill: "#EAF4FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0198 64.8544L62.6729 64.8104L86.9111 90.8459C86.9111 90.8459 87.1154 91.3768 87.0337 91.6624C86.9521 91.9479 87.4247 92.8962 88.4821 92.9878C89.474 93.0756 90.9319 93.3063 91.767 92.9658C92.5813 92.6363 102.703 69.9948 102.703 69.9948L103.152 70.1999L93.032 92.153C93.032 92.153 93.277 92.7241 92.9504 92.9255C92.6238 93.1305 91.0326 93.8665 90.6244 93.9067C90.2165 93.947 65.9373 104.107 65.9373 104.107L62.7952 102.884L61.8158 101.332L45.4531 84.1128L62.0198 64.8544Z",
    fill: "#0450CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.84 82.8899L62.0188 64.8544L86.2983 91.1718L62.6719 102.313L43.7383 84.0322L44.84 82.8899Z",
    fill: "#0561FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5566 79.419C36.5566 79.419 37.9033 78.8076 40.8001 77.5444C43.6973 76.2776 45.6971 74.3188 46.5538 74.3994C47.4109 74.4836 52.1032 77.1746 52.1032 77.1746L58.9586 80.4808C58.9586 80.4808 60.2643 81.6231 59.938 82.3188C59.6115 83.0107 59.3259 82.9705 58.7137 82.9302C58.1015 82.8899 51.6137 80.5211 51.6137 80.5211L60.6315 85.4602L63.2431 87.1334C63.2431 87.1334 63.8143 87.7045 63.8553 88.1512C63.8959 88.6015 63.692 89.1727 63.1208 89.1324C62.5496 89.0922 62.1414 89.1727 61.5292 88.8469C60.9174 88.521 56.7959 86.6428 56.7959 86.6428C56.7959 86.6428 61.3253 88.8066 62.1414 89.7036C62.9575 90.6006 62.9169 91.007 62.7536 91.4574C62.5903 91.9077 61.9781 91.9882 61.9781 91.9882L58.4691 90.1503C58.4691 90.1503 59.4892 90.7214 59.4075 90.9667C59.3259 91.212 58.9993 91.6221 58.5504 91.5818C58.1015 91.5379 54.1847 90.2345 54.1847 90.2345L50.3894 89.3375L45.4521 88.8066L39.2905 87.2542C39.2905 87.2542 38.1888 87.5398 38.0666 87.1736C37.9439 86.8075 34.9651 80.9714 36.5566 79.419Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.793 102.884L86.1337 92.0688C86.1337 92.0688 86.4193 92.7645 87.6026 93.2954C88.786 93.8263 91.2343 93.7018 91.2343 93.7018L65.9351 104.107C65.9351 104.107 62.9156 103.822 62.793 102.884Z",
    fill: "#0561FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.3813 98.2306C80.3813 98.2306 80.7489 98.886 80.3813 99.8233C80.014 100.761 79.9324 101.332 78.953 101.658C77.974 101.983 77.8923 102.027 77.4024 101.617C76.9129 101.211 74.8318 99.6182 74.8318 99.6182L73.1996 97.4141C73.1996 97.4141 72.7101 96.3963 73.3629 96.151C74.0157 95.9057 74.5873 95.8251 75.444 96.7624C76.3008 97.6997 77.8923 98.5162 78.3412 98.7212C78.8186 98.9372 80.3813 98.2306 80.3813 98.2306Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.9751 101.456C77.9751 101.456 78.2606 102.189 77.8934 102.679C77.5262 103.17 76.7917 103.781 76.1796 103.741C75.5674 103.701 71.6502 101.658 71.6502 101.658L68.6713 97.2532L66.3047 93.6615C66.3047 93.6615 66.5496 92.8853 67.0391 92.8048C67.5287 92.7242 67.8552 92.64 68.4268 93.1709C68.9979 93.7018 70.9974 96.7626 70.9974 96.7626L73.6903 98.9264C73.6903 98.9264 77.118 101.127 77.9751 101.456Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.3867 94.1923C62.3867 94.1923 62.5907 93.0903 63.2435 93.2111C63.8963 93.3356 64.9983 94.4376 66.1817 95.7008C67.365 96.9676 67.9768 97.6998 67.9768 97.6998L70.0582 99.168L74.7099 102.639L75.1178 103.17C75.1178 103.17 75.6483 103.942 74.9138 104.147C74.1794 104.352 73.6895 105.169 72.5065 104.638C71.3232 104.107 67.4466 101.211 67.4466 101.211L64.9983 97.9452L63.2665 95.4555L62.3867 94.1923Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5903 95.375C62.0602 95.3969 61.9375 96.1109 61.9375 96.1109L65.8547 101.863C65.8547 101.863 70.4248 105.129 70.874 105.374C71.3229 105.616 72.2613 105.455 72.5062 104.638C72.7508 103.822 66.2219 98.8862 66.2219 98.8862C66.2219 98.8862 63.651 95.3347 62.5903 95.375Z",
    fill: "#F7B68B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5164 85.105L37.3217 79.0712C38.2655 80.3234 38.9147 81.7696 39.1457 83.3659L39.584 86.4011C30.8954 92.8963 21.1721 98.6921 17.1399 95.7741C9.10077 89.9636 19.5164 85.105 19.5164 85.105Z",
    fill: "#F7B68B"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.498 96.9858C167.743 79.8583 145.708 37.6472 123.326 65.8172C112.254 78.672 102.755 102.928 99.1846 120.034C97.5238 128.246 97.0969 134.942 98.1261 140.369H202.973C206.367 132.475 207.546 124.636 206.746 119.36C205.452 109.621 198.541 106.505 188.498 96.9858Z",
    fill: "#EAF4FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.591 113.458C137.802 119.151 142.115 133.05 144.73 141.013H185.313L192.572 121.052C192.572 121.052 207.935 97.1287 181.484 81.2569C177.687 78.9796 157.943 80.6528 157.943 80.6528C157.943 80.6528 143.317 81.6304 123.922 110.723C123.315 111.635 137.287 105.257 137.591 113.458Z",
    fill: "#212957"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.893 67.2854C162.197 68.8049 164.825 73.4035 153.388 83.9919C145.186 91.5854 171.31 92.4971 180.423 80.953C180.423 80.953 166.45 79.1334 171.007 53.6178C174.426 34.4692 161.893 67.2854 161.893 67.2854Z",
    fill: "#F7B68B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.919 93.105L150.451 95.331C150.451 95.331 148.343 96.3122 148.831 96.5978C149.439 96.953 153.691 95.6349 153.691 95.6349C153.691 95.6349 154.906 96.1438 156.729 97.3557C158.552 98.5713 161.792 98.3699 161.792 98.3699C161.792 98.3699 172.93 120.037 182.853 123.684C192.776 127.331 194.193 125.709 195.611 123.076C197.028 120.444 199.66 108.698 189.535 105.66C179.41 102.624 164.019 97.1543 164.019 97.1543L159.159 92.0432L155.717 91.8894C155.717 91.8894 154.299 92.9036 153.489 93.5114",
    fill: "#F7B68B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.908 107.391C148.151 108.061 147.807 108.764 147.135 108.764H114.937C114.265 108.764 113.523 108.061 113.279 107.391L105.098 84.8706C104.854 84.197 105.199 83.6111 105.87 83.6111H138.069C138.74 83.6111 139.483 84.197 139.726 84.8706L147.908 107.391Z",
    fill: "#0561FC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.611 110.774C159.611 111.444 159.067 111.99 158.396 111.99H115.68C115.009 111.99 114.465 111.444 114.465 110.774V109.98C114.465 109.31 115.009 108.764 115.68 108.764H158.396C159.067 108.764 159.611 109.31 159.611 109.98V110.774Z",
    fill: "#0561FC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.933 111.99H117.847C117.847 111.99 112.987 113.634 117.543 119.408C122.1 125.178 126.808 123.571 129.39 122.505C131.972 121.443 140.629 113.502 140.629 113.502L144.274 113.934L148.83 111.8C148.83 111.8 147.767 111.184 146.401 111.792C145.033 112.4 144.274 112.246 144.274 112.246L142.907 111.485L143.818 110.419L144.274 109.357L142.148 110.599L140.933 111.99Z",
    fill: "#EC9568"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.469 68.1385C169.887 64.4479 169.917 59.7102 171.005 53.6178C174.424 34.4692 161.891 67.2854 161.891 67.2854C162.152 68.5889 164.119 72.1513 157.473 79.8144C162.868 78.6501 167.527 74.2932 170.469 68.1385Z",
    fill: "#EC9568"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.156 45.4128C159.156 45.4128 156.119 64.2465 157.334 68.501C158.549 72.7517 162.175 73.7439 166.446 67.8932C174.648 56.653 174.344 47.8439 171.915 46.3245C169.485 44.8087 162.801 39.0349 159.156 45.4128Z",
    fill: "#F7B68B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.321 48.1479C161.371 48.6238 156.727 50.2751 153.69 42.6815C150.652 35.088 157.335 33.5686 160.675 37.5155C160.905 37.7871 161.118 38.0487 161.314 38.2997C163.967 41.6995 163.567 43.1639 161.587 41.466C160.725 40.7263 160.762 39.3871 161.314 38.2997C162.122 36.7067 164.035 35.6542 165.84 37.8193C167.611 39.9458 168.763 42.691 169.114 44.55C169.365 45.879 169.207 46.7551 168.574 46.6284C167.99 46.5117 168.348 45.5434 169.114 44.55C170.341 42.9577 172.616 41.3011 173.738 42.9854C175.56 45.7204 176.775 49.6673 174.649 50.8828C174.205 51.1363 173.749 51.1519 173.323 51.0316C171.707 50.575 170.536 48.1608 172.219 49.3634C172.657 49.6761 173.03 50.2719 173.323 51.0316C174.454 53.9629 174.39 59.3343 172.219 60.2997C169.486 61.5152 169.486 59.388 171.916 56.9569C174.345 54.5258 171.005 49.5135 169.789 54.3757C169.684 54.7931 168.877 57.5647 168.877 57.5647L167.055 59.0841C167.055 59.0841 167.055 53.6178 168.27 51.6407C171.009 47.1923 170.926 47.0861 164.321 48.1479Z",
    fill: "#212957"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M161.314 38.2997C163.967 41.6995 163.567 43.1639 161.587 41.466C160.725 40.7263 160.762 39.3871 161.314 38.2997Z",
    fill: "#212957"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M169.114 44.55C169.365 45.879 169.207 46.7551 168.574 46.6284C167.99 46.5117 168.348 45.5434 169.114 44.55Z",
    fill: "#212957"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M173.323 51.0316C171.707 50.575 170.536 48.1608 172.219 49.3634C172.657 49.6761 173.03 50.2719 173.323 51.0316Z",
    fill: "#212957"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.645 112.316C142.645 112.316 126.212 113.897 122.083 114.315C119.352 114.589 116.83 115.739 116.125 117.189C116.433 117.855 116.888 118.595 117.542 119.422C122.099 125.192 126.807 123.578 129.389 122.516C131.971 121.451 140.628 113.506 140.628 113.506L144.275 113.945C144.446 113.63 142.954 112.367 142.645 112.316Z",
    fill: "#F7B68B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.236 123.728C194.162 124.479 193.812 125.061 192.067 124.83C189.389 124.471 181.016 119.693 177.048 116.68C170.761 111.906 162.153 98.4174 161.816 98.4247C162.415 99.5781 173.206 120.14 182.85 123.684C191.919 127.016 193.883 125.947 195.236 123.728Z",
    fill: "#EC9568"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 140.874H216.843V139.995H0V140.874Z",
    fill: "#7EB3FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.4221 151.858L52.3906 146.571L52.6367 136.521L80.1085 140.628L78.4221 151.858Z",
    fill: "#EAF4FE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.778 136.052L84.2889 131.343L94.4874 129.901L123.787 135.276C123.787 135.276 126.169 140.79 123.094 146.271C122.873 146.662 78.0416 153 78.0416 153L52.3331 147.007C52.3331 147.007 49.4099 145.333 53.1166 145.754C56.2994 146.117 77.3482 151.525 77.3482 151.525C77.3482 151.525 80.5236 146.758 76.948 140.976C76.6851 140.548 52.4374 136.986 52.4374 136.986C52.4374 136.986 50.5127 136.799 51.778 136.052Z",
    fill: "#DD000B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.533 140.211C124.591 137.861 123.23 135.946 123.23 135.946L79.184 140.984C81.3463 147.211 79.1642 150.902 77.6484 152.561C87.8309 151.224 122.801 146.604 123.002 146.267C123.753 145.015 124.194 143.759 124.433 142.569C124.481 141.694 124.517 140.859 124.533 140.211Z",
    fill: "#FD2227"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5967 138.073L75.8422 141.841L52.5586 138.637",
    fill: "#C5E1F9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5547 139.494L67.2094 141.76L52.6001 139.798",
    fill: "#C5E1F9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4453 144.081L73.4524 148.724L52.4911 144.381",
    fill: "#C5E1F9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4883 142.316L77.0358 146.483L52.534 142.617",
    fill: "#C5E1F9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1999 141.364L45.0469 136.715V126.664L72.6113 130.095L71.1999 141.364Z",
    fill: "#EAF4FE"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1733 126.214L76.5593 120.711L86.7194 119.02L116.142 123.677C116.142 123.677 118.658 129.128 115.718 134.683C115.507 135.082 70.844 142.514 70.844 142.514L44.9967 137.15C44.9967 137.15 42.0333 135.554 45.7491 135.883C48.9399 136.165 70.115 141.057 70.115 141.057C70.115 141.057 73.1726 136.209 69.4564 130.52C69.1832 130.102 44.8554 127.133 44.8554 127.133C44.8554 127.133 42.927 126.99 44.1733 126.214Z",
    fill: "#0561FC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.013 128.59C117.013 126.24 115.606 124.358 115.606 124.358L71.6967 130.472C74.011 136.645 71.9197 140.387 70.4453 142.086C80.5919 140.497 115.438 135.023 115.632 134.683C116.35 133.412 116.761 132.145 116.971 130.948C116.998 130.073 117.013 129.238 117.013 128.59Z",
    fill: "#0450CF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0437 128.213L68.3746 131.413L45.0195 128.781",
    fill: "#C5E1F9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0391 129.637L59.7447 131.541L45.0918 129.938",
    fill: "#C5E1F9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0391 134.225L66.153 138.351L45.0918 134.525",
    fill: "#C5E1F9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0391 132.46L69.681 136.023L45.0918 132.76",
    fill: "#C5E1F9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.9082 131.087L110.309 127.104V118.496L86.6992 121.436L87.9082 131.087Z",
    fill: "#C5E1F9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.058 118.111L83.318 113.396L74.6151 111.946L49.4136 115.937C49.4136 115.937 47.2582 120.608 49.7761 125.365C49.9573 125.705 88.2131 132.072 88.2131 132.072L110.353 127.477C110.353 127.477 112.891 126.108 109.708 126.39C106.975 126.631 88.8377 130.823 88.8377 130.823C88.8377 130.823 86.2188 126.672 89.4019 121.798C89.6359 121.44 110.474 118.895 110.474 118.895C110.474 118.895 112.125 118.774 111.058 118.111Z",
    fill: "#FFAB01"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.668 120.147C48.668 118.13 49.8729 116.519 49.8729 116.519L87.4839 121.758C85.5013 127.045 87.2928 130.249 88.5556 131.706C79.8644 130.344 50.0168 125.657 49.8513 125.364C49.2355 124.273 48.8836 123.19 48.7035 122.165C48.6811 121.418 48.668 120.7 48.668 120.147Z",
    fill: "#FEC12F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.312 119.825L90.3281 122.564L110.333 120.308",
    fill: "#9AC7F7"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.315 121.041L97.7188 122.673L110.269 121.3",
    fill: "#9AC7F7"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.316 124.969L92.2305 128.506L110.27 125.225",
    fill: "#9AC7F7"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.318 123.461L89.2109 126.511L110.273 123.717",
    fill: "#9AC7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPractice);
export default __webpack_public_path__ + "static/media/practice.eafc6a6d368e7eb744e195a55e63cdf6.svg";
export { ForwardRef as ReactComponent };